import axios from 'axios'
import { TokenStorage } from 'services/tokenService'
import { history, routePath } from 'routes'

export default () => {
  axios.interceptors.response.use(
    response => response,
    error => {
       if (
            error.response.status === 401  &&
            error.response.config.url === `${axios.defaults.baseURL}/authenticate`
          ) {
            console.log("Login ", error)
            return new Promise((resolve, reject) => {
              reject(error)
          })
       }
      // Return any error which is not due to authentication back to the calling service
      if (
        error.response.status !== 401 ||
        error.response.config.url === `${axios.defaults.baseURL}/authenticate`
      ) {
        return new Promise((resolve, reject) => {
          reject(error)
        })
      }

      // Logout user if token refresh didn't work or user is disabled
      if (
        // error.config.url === `${axios.defaults.baseURL}/refresh` ||
        !!TokenStorage.getRefreshToken()
      ) {
        TokenStorage.clear()
        history.push(routePath.SIGN_IN)

        return new Promise((resolve, reject) => {
          reject(error.config)
        })
      }

      // Try request again with new token
      return (
        TokenStorage.getNewToken()
          .then(token => {
            // New request with new token
            const config = error.config
            config.headers.Authorization = `Bearer ${token}`

            return new Promise((resolve, reject) => {
              axios
                .request(config)
                .then(response => {
                  resolve(response)
                })
                // tslint:disable-next-line:no-shadowed-variable
                .catch(error => {
                  reject(error)
                })
            })
          })
          // tslint:disable-next-line:no-shadowed-variable
          .catch(error => {
            Promise.reject(error)
          })
      )
    }
  )
}
